const form_messages = {
  Common: {
    INVALID: (name) => `${name} is invalid.`,
  },

  Signup: {
    businessemail: {
      Invalid: "Enter a valid email address.",
      Required: "Business email cannot be empty.",
    },
    email: {
      Invalid: "Enter a valid email address.",
      Required: "Email cannot be empty.",
    },
    name: {
      MIN1CHARMAX35: "The minimum and maximum characters allowed are 1 and 35.",
      Required: "Name cannot be empty.",
    },
    firstname: {
      MIN1MAX35:
        "The minimum and maximum characters allowed are 1 and 35.",
      Required: "First name cannot be empty.",
    },
    lastname: {
      MIN1MAX35:
        "The minimum and maximum characters allowed are 1 and 35.",
      Required: "Last name cannot be empty.",
    },
    jobrole: {
      MIN3MAX20:
        "The minimum and maximum characters allowed are 3 and 20.",
      Required: "Role cannot be empty.",
    },
    companyname: {
      MIN3MAX100: "The minimum and maximum characters allowed are 3 and 100.",
      Required: "Company name cannot be empty.",
    },
    employeeno: {
      Invalid: "No.of Employees should be in range 1 to 999999.",
      Required: "No.of Employees field should not be empty.",
      NONNEGATIVE: "No.of Employees should not be negative",
    },
    phone: {
      MINMAX: (min, max) => `The minimum and maximum digits allowed are ${min} and ${max}.`,
      INVALID: "Enter a valid phone number.",
      NONNEGATIVE: "Phone number should not be negative",
      Required: "Phone number cannot be empty.",
    },
    terms: {
      AGREE: "Please accept the Terms & Conditions.",
    },
    cmp_address: {
      MIN5MAX100: "The minimum and maximum characters allowed are 5 and 100.",
      Required: "Company address field should not be empty.",
    },
    password: {
      MATCH:
        "Your password should contain 8-16 characters with a combination of uppercase, lowercase, special character and number.",
      SAME: "Passwords do not match. Please try again!",
      Required: "Password cannot be empty.",
      ConfirmRequired: "Confirm password cannot be empty.",
      CurrentPassword: "Current password cannot be empty.",
      NewPassword: "New password cannot be empty.",
    },
  },
  Application: {
    appname: {
      MIN3MAX35:
        "The minimum and maximum characters allowed are 3 and 35.",
      Required: "App name cannot be empty.",
      NOSPACES: "App name cannot contain empty space.",

    },
    appDescription: {
      MIN3MAX100:
        "The minimum and maximum characters allowed are 3 and 100.",
      Required: "Description cannot be empty.",
    },
    appIcon: {
      Invalid: "Invalid File Format.",
      Exceeded: "File Should not exceed more than 5MB.",
      Required: "App icon cannot be empty.",


    }
  },
  Billing_Address: {
    bill_name: {
      MIN1MAX50: "The minimum and maximum characters allowed are 1 and 50.",
      REQUIRED: "Billing name cannot be empty.",

    },
    bill_email: {
      INVALID: "Enter a valid email address.",
      REQUIRED: "Billing email cannot be empty.",
    },
    address_line: {
      ADD_L1: {
        MIN1MAX100: "The minimum and maximum characters allowed are 1 and 100.",
        REQUIRED: "Address line 1 cannot be empty.",

      },
      ADD_L2: {
        MIN1MAX100: "The minimum and maximum characters allowed are 1 and 100.",

      }
    },
    city: {
      MIN2MAX100: "The minimum and maximum characters allowed are 2 and 100.",
      REQUIRED: "City cannot be empty.",

    },
    State: {
      MIN2MAX100: "The minimum and maximum characters allowed are 2 and 100.",
      REQUIRED: "State cannot be empty.",

    },
    Country_name: {
      MIN2MAX20: "The minimum and maximum characters allowed are 2 and 20.",
      REQUIRED: "Country cannot be empty.",

    },
    Zip_code: {
      INVALID: "Enter a valid Zip code.",
      NONNEGATIVE: "Zip code cannot be negative.",
      ZIPCODECHAR: "The minimum and maximum digits allowed are 5 and 8.",
      REQUIRED: "Zip code cannot be empty.",
    },
    Gstin_no: {
      INVALID: "Enter a valid GSTIN number.",
      MAX200CHAR: "The maximum characters allowed is 200."
    }
  }
}
export default form_messages
